// Typelizer digest 44b21f4146f7ffd4559dbd6c6d00a7b1
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** PATCH /c/:company_id/ledger/payments/:payment_id/category */
  update: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/ledger/payments/:payment_id/category', params, options),
    method: 'patch',
  }),
}
